import { render, staticRenderFns } from "./ProdutoSilenciado.vue?vue&type=template&id=a4ec5a62&scoped=true"
import script from "./ProdutoSilenciado.vue?vue&type=script&lang=js"
export * from "./ProdutoSilenciado.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4ec5a62",
  null
  
)

export default component.exports